import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
// eslint-disable-next-line @nrwl/nx/enforce-module-boundaries
import { BaseCRUDApiClient } from '@ideapa/app-base-api-client';
import { TipologiaPartecipazioneDto } from '@ideapa/common-dto';

import { ApiClientConfig } from '../api-client-config';

@Injectable()
export class TipologiaPartecipazioneApiClient extends BaseCRUDApiClient<TipologiaPartecipazioneDto> {
  baseUrl = this.config.apiEndpoint + '/tipologia-partecipazione';

  constructor(http: HttpClient, private config: ApiClientConfig) {
    super(http);
  }
}
